import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LanguageSwitcher from '../../Component/LanguageSwitcher';

const PMJanDhan = () => {
  const { t } = useTranslation('PMJanDhan');



  document.title = t('documentTitle');
  document.querySelector('meta[name="description"]').setAttribute('content', t('metaDescription'));



  return (
    <div>
      <header className="d-flex justify-content-end align-items-center p-3 border-bottom">
        <LanguageSwitcher />
      </header>

      <div className="webview">
        <Container>
          <Row>
            <Col xs={12}>
              <Trans
                i18nKey="intro1"
                ns="PMJanDhan"
                components={[
                  <strong key="0" />,
                  <strong key="1" />,
                  <a
                    key="2"
                    title="Pradhan Mantri Jeevan Jyoti Bima Yojana"
                    href="https://www.goodreturns.in/personal-finance/insurance/2015/03/pradhan-mantri-jeevan-jyoti-bima-yojana-highlights-the-scheme-340701.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                  <a
                    key="3"
                    title="Pradhan Mantri Suraksha Bima Yojana"
                    href="https://www.goodreturns.in/personal-finance/insurance/2018/09/pradhan-mantri-suraksha-bima-yojana-how-get-rs-2-lakh-insur-766980.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                  <a
                    key="4"
                    title="Pradhan Mantri Mudra Yojana"
                    href="https://www.goodreturns.in/classroom/2018/03/how-apply-pradhan-mantri-mudra-yojana-loan-scheme/articlecontent-pf11657-682167.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                  <a
                    key="5"
                    title="Atal Pension Yojana"
                    href="https://www.goodreturns.in/classroom/2018/01/how-apply-atal-pension-yojana-663429.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                ]}
              />
              <br />
              <br />
              <p>
                <Trans
                  i18nKey="intro2"
                  ns="PMJanDhan"
                  components={[<strong key="0" />]}
                />

              </p>
              <p>
                <Trans
                  i18nKey="intro3"
                  ns="PMJanDhan"
                  components={[<strong key="0" />]}
                />
              </p>
              <p>
                <Trans
                  i18nKey="intro4"
                  ns="PMJanDhan"
                  components={[<strong key="0" />]}
                />
              </p>

              <h2>{t('eligibilityHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('eligibilityIntro') }} />
              <ul>
                {t('eligibilityList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('documentsHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('documentsIntro') }} />
              <ul>
                {t('documentsList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('attainmentHeader')}</h2>
              <ul>
                {t('attainmentList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('missionHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('missionIntro') }} />
              <p>
                <Trans
                  i18nKey="missionObjective1"
                  ns="PMJanDhan"
                  components={[<strong key="0" />]}
                />
              </p>
              <p>
                <Trans
                  i18nKey="missionObjective2"
                  ns="PMJanDhan"
                  components={[<strong key="0" />]}
                />
              </p>
              <p>
                <Trans
                  i18nKey="missionObjective3"
                  ns="PMJanDhan"
                  components={[<strong key="0" />]}
                />
              </p>
              <p>
                <Trans
                  i18nKey="missionObjective4"
                  ns="PMJanDhan"
                  components={[<strong key="0" />]}
                />
              </p>
              <p>
                <Trans
                  i18nKey="missionObjective5"
                  ns="PMJanDhan"
                  components={[<strong key="0" />]}
                />
              </p>

              <h2>{t('insuranceHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('insuranceIntro') }} />
              <h3>{t('insuranceEligibilityHeader')}</h3>
              <p dangerouslySetInnerHTML={{ __html: t('insuranceEligibilityIntro') }} />
              <ul>
                {t('insuranceEligibilityList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('claimSettlementHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('claimSettlementIntro') }} />
              <p dangerouslySetInnerHTML={{ __html: t('claimSettlementSubIntro') }} />
              <ul>
                {t('claimSettlementList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('featuresHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('featuresIntro') }} />
              <ul>
                {t('featuresList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('banksHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('banksIntro') }} />
              <h3>
                <Trans
                  i18nKey="banksPrivateHeader"
                  ns="PMJanDhan"
                  components={[<strong key="0" />]}
                />
              </h3>
              <ul>
                {t('banksPrivateList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('milestoneHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('milestoneIntro') }} />
              <p dangerouslySetInnerHTML={{ __html: t('milestoneAdditional') }} />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default PMJanDhan;